var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"main"},[_vm._v(" "+_vm._s(_vm.title.main)+" ")]),_c('div',{staticClass:"sub"},_vm._l((_vm.title.sub),function(s){return _c('div',[_vm._v(" "+_vm._s(s)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }